import { Component } from '@angular/core';

@Component({
  selector: 'subscription-card',
  imports: [],
  standalone: true,
  templateUrl: './subscription-card.component.html'
})
export class SubscriptionCardComponent {}
